import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=390ded82&"
import script from "./FormTable.vue?vue&type=script&lang=ts&"
export * from "./FormTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390ded82')) {
      api.createRecord('390ded82', component.options)
    } else {
      api.reload('390ded82', component.options)
    }
    module.hot.accept("./FormTable.vue?vue&type=template&id=390ded82&", function () {
      api.rerender('390ded82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoodsReceiptChecklist/FormTable.vue"
export default component.exports